import React, { useState, useContext } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LanguageContext } from '../../context/LanguageContext';
import './Navbar.css';

const Navbar = () => {
  const { t } = useTranslation();
  const { language, changeLanguage } = useContext(LanguageContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  
  const direction = language === 'ar' ? 'rtl' : 'ltr';

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    // When menu is closing, we need to ensure transitions work correctly
    if (menuOpen) {
      const menu = document.querySelector('.navbar-menu');
      if (menu) {
        menu.style.transition = direction === 'rtl' ? 'left 0.3s ease' : 'right 0.3s ease';
      }
    }
  };

  const toggleLanguage = (lang) => {
    // Close menu before changing language to avoid transition issues
    setMenuOpen(false);
    changeLanguage(lang);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const scrollToAbout = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    
    // If not on home page, navigate to home page first
    if (location.pathname !== '/') {
      navigate('/');
      // Use setTimeout to wait for navigation to complete
      setTimeout(() => {
        const aboutSection = document.querySelector('#about-section');
        if (aboutSection) {
          aboutSection.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      // Already on home page, just scroll
      const aboutSection = document.querySelector('#about-section');
      if (aboutSection) {
        aboutSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const scrollToFooter = (e) => {
    e.preventDefault();
    setMenuOpen(false);
    
    // Close the menu if it's open
    if (menuOpen) {
      setMenuOpen(false);
    }
    
    // Find the footer element
    const footer = document.querySelector('footer');
    if (footer) {
      // Scroll to footer
      footer.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`navbar ${direction}`}>
      <div className={`container navbar-container ${direction}`}>
        <Link to="/" className="navbar-logo">
          <img src="/logo.svg" alt="Baleeg" />
        </Link>

        <div className={`navbar-menu ${menuOpen ? 'active' : ''} ${direction}`}>
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/" className={`nav-link ${isActive('/')}`}>{t('nav.home')}</Link>
            </li>
            <li className="nav-item">
              <Link to="/services" className={`nav-link ${isActive('/services')}`}>{t('nav.services')}</Link>
            </li>
            <li className="nav-item">
              <a href="#about-section" onClick={scrollToAbout} className="nav-link">{t('nav.about')}</a>
            </li>
            <li className="nav-item">
              <a href="#footer" onClick={scrollToFooter} className="nav-link">{t('nav.contact')}</a>
            </li>
            <li className="nav-item">
              <Link to="/track-order" className={`nav-link ${isActive('/track-order')}`}>{t('nav.tracking')}</Link>
            </li>

            
          </ul>
          <div className="language-toggle-wrapper">
            <button
              className={`language-option ${language === 'ar' ? 'active' : ''}`}
              onClick={() => toggleLanguage('ar')}
            >
              AR
            </button>
            <button
              className={`language-option ${language === 'en' ? 'active' : ''}`}
              onClick={() => toggleLanguage('en')}
            >
              EN
            </button>
          </div>
        </div>

        <button
          className={`navbar-toggler ${menuOpen ? 'active' : ''}`}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </nav>
  );
};

export default Navbar; 